<template>
  <div class="process">
    <div class="process_content">
      <div class="process_item" v-for="(item,index)  in processList" :key="index">
        <div class="img_item">
          <img :src="imgs[index]" alt="">
        </div>
        <div class="step_word">{{ item }}</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      // imgs: {
      //   tel: require("@/assets/image/financialInsurance/insurance/tel.png"),
      //   chakan: require("@/assets/image/financialInsurance/insurance/survey.png"),
      //   dingsun: require("@/assets/image/financialInsurance/insurance/dingsun.png"),
      //   chakan: require("@/assets/image/financialInsurance/insurance/lipei.png"),
      //   chakan: require("@/assets/image/financialInsurance/insurance/shenhe.png"),
      // },
      imgs: [
        require("@/assets/image/financialInsurance/insurance/tel.png"),
        require("@/assets/image/financialInsurance/insurance/survey.png"),
        require("@/assets/image/financialInsurance/insurance/dingsun.png"),
        require("@/assets/image/financialInsurance/insurance/lipei.png"),
        require("@/assets/image/financialInsurance/insurance/shenhe.png"),
        require("@/assets/image/financialInsurance/insurance/zhifu.png"),
      ],
      processList: [
        "1.拨打95540报案",
        "2.查勘",
        "3.定损",
        "4.理赔公示",
        "5.提交资料并审核",
        "6.赔款支付",
      ],
    };
  },
  computed: {},
  created() {},
  methods: {},
  mounted() {},
};
</script>

<style lang='scss' scoped >
.process {
  width: 94%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 20px;
  .process_content {
    width: 100%;
    display: flex;
    .process_item {
      width: calc(20% - 12px);
      height: 60px;
      position: relative;
      .img_item {
        height: 100%;
        width: 60px;
        border-radius: 50%;
        border: 1px solid #8adcb1;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 70%;
          width: 70%;
        }
      }
      .step_word {
        position: absolute;
        bottom: -40px;
        left: 0;
        height: 36px;
        line-height: 36px;
        text-align: left;
        width: 100%;
        &:last-child {
          width: 140%;
        }
      }
      &::after {
        content: " ";
        position: absolute;
        right: 0;
        top: 50%;
        height: 0;
        border-bottom: 1px dashed #8adcb1;
        width: calc(100% - 61px);
      }
      &:nth-of-type(6) {
        width: 60px;
      }
      &:nth-of-type(6)::after {
        content: " ";
        display: none;
        position: absolute;
        right: 0;
        top: 50%;
        height: 0;
        border-bottom: 1px dashed #8adcb1;
        width: calc(100% - 61px);
      }
    }
    // height: ;
  }
}
</style>
